
import { useState } from 'react';

export default function Testimonials() {
  const [activeIndex, setActiveIndex] = useState(0);

  const testimonials = [
    {
      quote: 'A parceria com a Feenex transformou nossa gestão tributária. Em menos de um ano, conseguimos uma economia significativa com total segurança jurídica. A equipe é extremamente profissional e transparente em todas as etapas.',
      author: 'Ricardo Mendes',
      role: 'CFO',
      company: 'Grupo Construtora Horizonte',
      image: 'https://public.readdy.ai/ai/img_res/68ac5fc9e86636c1853b5f329b222779.jpg'
    },
    {
      quote: 'Buscávamos uma solução de eficiência tributária que fosse 100% legal e auditável. A Feenex entregou exatamente isso, com documentação impecável e suporte dedicado. Recomendo para qualquer empresa que valorize conformidade.',
      author: 'Fernanda Costa',
      role: 'Diretora Financeira',
      company: 'Indústrias Metalúrgicas São Paulo',
      image: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20female%20executive%20in%20elegant%20business%20attire%20corporate%20headshot%20portrait%20neutral%20gray%20background%20confident%20smile%20business%20leader%20high%20quality%20photography&width=120&height=120&seq=testimonial2&orientation=squarish'
    },
    {
      quote: 'O diferencial da Feenex está na transparência e no acompanhamento próximo. Temos relatórios detalhados mensalmente e um gestor dedicado que conhece profundamente nossa operação. É uma parceria de verdade.',
      author: 'Carlos Eduardo Silva',
      role: 'CEO',
      company: 'Logística Express Brasil',
      image: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20male%20CEO%20executive%20in%20premium%20business%20suit%20corporate%20headshot%20portrait%20neutral%20background%20mature%20confident%20expression%20business%20leader%20high%20quality%20photography&width=120&height=120&seq=testimonial3&orientation=squarish'
    },
    {
      quote: 'Após anos trabalhando com consultorias tradicionais, encontramos na Feenex uma abordagem diferenciada. A estruturação com direitos creditórios nos proporcionou resultados consistentes e sustentáveis.',
      author: 'Mariana Alves',
      role: 'Controller',
      company: 'Rede Farmacêutica Nacional',
      image: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20female%20controller%20executive%20in%20formal%20business%20attire%20corporate%20headshot%20portrait%20neutral%20gray%20background%20professional%20expression%20business%20woman%20high%20quality%20photography&width=120&height=120&seq=testimonial4&orientation=squarish'
    }
  ];

  const nextTestimonial = () => {
    setActiveIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setActiveIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section id="depoimentos" className="py-24 bg-feenex-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-feenex-gold/10 rounded-full mb-4">
            <span className="text-sm font-semibold text-feenex-gold uppercase tracking-wider">Depoimentos</span>
          </div>
          <h4 className="text-4xl lg:text-5xl font-bold text-feenex-blue mb-6">
            <a href="#depoimentos" className="hover:text-feenex-gold transition-colors">
              O Que Nossos Clientes Dizem
            </a>
          </h4>
          <p className="text-lg text-feenex-blue/70 max-w-3xl mx-auto">
            Empresas de diversos setores confiam na Feenex para otimizar sua gestão tributária com segurança e transparência.
          </p>
        </div>

        {/* Main Testimonial Card */}
        <div className="relative max-w-4xl mx-auto">
          <div className="bg-white rounded-lg shadow-xl p-10 lg:p-14 border border-feenex-blue/5">
            {/* Quote Icon */}
            <div className="absolute -top-6 left-10">
              <div className="w-12 h-12 bg-feenex-gold rounded-lg flex items-center justify-center shadow-lg">
                <i className="ri-double-quotes-l text-2xl text-white"></i>
              </div>
            </div>

            {/* Testimonial Content */}
            <div className="pt-4">
              <p className="text-xl lg:text-2xl text-feenex-blue/80 leading-relaxed italic mb-10">
                "{testimonials[activeIndex].quote}"
              </p>

              <div className="flex items-center justify-between flex-wrap gap-6">
                {/* Author Info */}
                <div className="flex items-center gap-4">
                  <div className="w-16 h-16 rounded-full overflow-hidden border-2 border-feenex-gold/30">
                    <img 
                      src={testimonials[activeIndex].image} 
                      alt={testimonials[activeIndex].author}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div>
                    <h5 className="text-lg font-bold text-feenex-blue">
                      {testimonials[activeIndex].author}
                    </h5>
                    <p className="text-sm text-feenex-blue/60">
                      {testimonials[activeIndex].role}
                    </p>
                    <p className="text-sm font-medium text-feenex-gold">
                      {testimonials[activeIndex].company}
                    </p>
                  </div>
                </div>

                {/* Navigation Arrows */}
                <div className="flex items-center gap-3">
                  <button 
                    onClick={prevTestimonial}
                    className="w-12 h-12 rounded-full border-2 border-feenex-blue/20 flex items-center justify-center hover:border-feenex-gold hover:bg-feenex-gold/5 transition-all cursor-pointer"
                    aria-label="Depoimento anterior"
                  >
                    <i className="ri-arrow-left-s-line text-xl text-feenex-blue"></i>
                  </button>
                  <button 
                    onClick={nextTestimonial}
                    className="w-12 h-12 rounded-full border-2 border-feenex-blue/20 flex items-center justify-center hover:border-feenex-gold hover:bg-feenex-gold/5 transition-all cursor-pointer"
                    aria-label="Próximo depoimento"
                  >
                    <i className="ri-arrow-right-s-line text-xl text-feenex-blue"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Dots Indicator */}
          <div className="flex justify-center gap-2 mt-8">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setActiveIndex(index)}
                className={`w-3 h-3 rounded-full transition-all cursor-pointer ${
                  index === activeIndex 
                    ? 'bg-feenex-gold w-8' 
                    : 'bg-feenex-blue/20 hover:bg-feenex-blue/40'
                }`}
                aria-label={`Ver depoimento ${index + 1}`}
              />
            ))}
          </div>
        </div>

        {/* Client Logos */}
        <div className="mt-20 pt-12 border-t border-feenex-blue/10">
          <p className="text-center text-sm text-feenex-blue/50 uppercase tracking-wider mb-8">
            Empresas que confiam na Feenex
          </p>
          <div className="flex flex-wrap justify-center items-center gap-12 lg:gap-16 opacity-60">
            <div className="text-feenex-blue/40 font-bold text-xl tracking-wider">HORIZONTE</div>
            <div className="text-feenex-blue/40 font-bold text-xl tracking-wider">METALSP</div>
            <div className="text-feenex-blue/40 font-bold text-xl tracking-wider">EXPRESS</div>
            <div className="text-feenex-blue/40 font-bold text-xl tracking-wider">FARMA+</div>
            <div className="text-feenex-blue/40 font-bold text-xl tracking-wider">AGROBRASIL</div>
          </div>
        </div>
      </div>
    </section>
  );
}
